<template>
  <b-tab>
    <template v-slot:title>Charges</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">Withdraw Charges</h4>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Charges</div>
          <div class="col-3">Add New Charges</div>
          <div class="col-2">Edit Charges</div>
          <div class="col-3">Delete Charges</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in permissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Withdraw Charges -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_withdraw_charges == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_withdraw_charges')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_withdraw_charges')" />
          </div>

          <!-- New Withdraw Charges -->
          <div class="col-3">
            <RockerSwitch v-if="item.new_withdraw_charges == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_withdraw_charges')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_withdraw_charges')" />
          </div>

          <!-- Edit Withdraw Charges -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_withdraw_charges == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_withdraw_charges')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_withdraw_charges')" />
          </div>

          <!-- Delete Withdraw Charges -->
          <div class="col-3">
            <RockerSwitch v-if="item.delete_withdraw_charges == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_withdraw_charges')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_withdraw_charges')" />
          </div>
        </div>
      </div>
      <hr>
      <h4 class="text-black">Loan Charges</h4>
      <div class="row fw-bold text-black mb-2">
        <div class="col-2">Role Name</div>
        <div class="col-2">View Charges</div>
        <div class="col-3">Add New Charges</div>
        <div class="col-2">Edit Charges</div>
        <div class="col-3">Delete Charges</div>
      </div>
      <div class="row mb-2 border-bottom" v-for="item in permissions" :key="item.id">
        <div class="col-2">{{ item.rolename }}</div>

        <!-- View Loan Charges -->
        <div class="col-2">
          <RockerSwitch v-if="item.view_loan_charges == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_loan_charges')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_loan_charges')" />
        </div>

        <!-- New Loan Charges -->
        <div class="col-3">
          <RockerSwitch v-if="item.new_loan_charges == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'new_loan_charges')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'new_loan_charges')" />
        </div>

        <!-- Edit Loan Charges -->
        <div class="col-2">
          <RockerSwitch v-if="item.edit_loan_charges == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'edit_loan_charges')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'edit_loan_charges')" />
        </div>

        <!-- Delete Loan Charges -->
        <div class="col-3">
          <RockerSwitch v-if="item.delete_loan_charges == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'delete_loan_charges')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'delete_loan_charges')" />
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";

import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "ChargePermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>